import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

import resourcesAppVue from "../images/resources-app-vue.png";
import findJobsVueTs from "../images/find-jobs-vue-ts.png";
import toDoVueApp from "../images/todo-vue-app.png";
import musicPlayer from "../images/music-player.png";
import videoPlayer from "../images/video-player.png";
import customCountdown from "../images/custom-countdown.png";
import formValidation from "../images/form-validation.png";
import rockPaperScissors from "../images/rock-paper-scissors.png";
import nasaApiPictures from "../images/nasa-api-pictures.png";
import calculator from "../images/calculator.png";
import animatedNavigation from "../images/animated-navigation.png";
import youtubeClone from "../images/youtube-clone.png";
import currencyConverter from "../images/currency-converter.png";
import bitcoinTrackerApp from "../images/bitcoin-tracker-app.png";
import lightDarkMode from "../images/light-dark-mode.png";
import jokeTeller from "../images/joke-teller.png";

const Projects = () => {
	useEffect(() => {
		Aos.init({
			duration: 1500,
			delay: 200,
			offset: 0,
			easing: "ease",
			once: true,
			mirror: false,
			disable: () => {
				return window.innerWidth < 600;
			},
		});

		window.scrollTo(0, 0);
	}, []);

	const projects = [
		{
			image: findJobsVueTs,
			title: "Find Jobs - Vue TS",
			liveLink: "https://find-jobs-vue3-ts-app.netlify.app/",
			gitLink: "https://github.com/mr-mahawar/Find_Jobs-Vue_TS_App",
		},
		{
			image: toDoVueApp,
			title: "To Do App - Vue",
			liveLink: "https://todo-vue-app-tilak.netlify.app/",
			gitLink: "https://github.com/mr-mahawar/To-Do-Vue-App",
		},
		{
			image: resourcesAppVue,
			title: "Resources App - Vue",
			liveLink: "https://resource-app-vue.netlify.app/",
			gitLink: "https://github.com/mr-mahawar/Resources-App-Vue",
		},
		{
			image: musicPlayer,
			title: "Music Player",
			liveLink: "https://mr-mahawar.github.io/Music-Player/",
			gitLink: "https://github.com/mr-mahawar/Music-Player",
		},
		{
			image: videoPlayer,
			title: "Video Player",
			liveLink: "https://mr-mahawar.github.io/Video-Player/",
			gitLink: "https://github.com/mr-mahawar/Video-Player",
		},
		{
			image: customCountdown,
			title: "Custom Countdown",
			liveLink: "https://mr-mahawar.github.io/Custom-Countdown/",
			gitLink: "https://github.com/mr-mahawar/Custom-Countdown",
		},
		{
			image: formValidation,
			title: "Form Validation",
			liveLink: "https://mr-mahawar.github.io/Form-Validation/",
			gitLink: "https://github.com/mr-mahawar/Form-Validation",
		},
		{
			image: rockPaperScissors,
			title: "Rock Paper Scissors Game",
			liveLink: "https://mr-mahawar.github.io/Rock-Paper-Scissors/",
			gitLink: "https://github.com/mr-mahawar/Rock-Paper-Scissors",
		},
		{
			image: nasaApiPictures,
			title: "NASA API Pictures",
			liveLink: "https://mr-mahawar.github.io/NASA-API-Pictures/",
			gitLink: "https://github.com/mr-mahawar/NASA-API-Pictures",
		},
		{
			image: calculator,
			title: "Calculator",
			liveLink: "https://mr-mahawar.github.io/Calculator/",
			gitLink: "https://github.com/mr-mahawar/Calculator",
		},
		{
			image: animatedNavigation,
			title: "Animated Navigation",
			liveLink: "https://mr-mahawar.github.io/Animated-Navigation/",
			gitLink: "https://github.com/mr-mahawar/Animated-Navigation",
		},
		{
			image: youtubeClone,
			title: "Youtube Clone",
			liveLink: "https://tube-clone.netlify.app/",
			gitLink: "https://github.com/mr-mahawar/Youtube-Clone",
		},
		{
			image: currencyConverter,
			title: "Currency Converter",
			liveLink: "https://currency-converter-tilak.netlify.app/",
			gitLink: "https://github.com/mr-mahawar/Currency-Converter",
		},
		{
			image: bitcoinTrackerApp,
			title: "Bit-Coin Tracker App",
			liveLink: "https://bitcoin-tracker-app.netlify.app/",
			gitLink: "https://github.com/mr-mahawar/BitCoin-App",
		},
		{
			image: lightDarkMode,
			title: "Light & Dark Mode",
			liveLink: "https://mr-mahawar.github.io/Light-Dark-Mode/",
			gitLink: "https://github.com/mr-mahawar/Light-Dark-Mode",
		},
		{
			image: jokeTeller,
			title: "Joke Teller",
			liveLink: "https://mr-mahawar.github.io/Joke_Teller/",
			gitLink: "https://github.com/mr-mahawar/Joke_Teller",
		},
	];

	const renderProjects = () => {
		return projects.map((project) => {
			return (
				<div
					className="project"
					style={{ backgroundImage: `url(${project.image})` }}
					key={project.title}
				>
					<div className="project-content">
						<div className="title">{project.title}</div>
						<div className="bottom-part">
							<a
								href={project.liveLink}
								target="_blank"
								rel="noreferrer"
							>
								<div className="visit button">
									Visit{" "}
									<i className="fas fa-location-arrow"></i>
								</div>
							</a>
							<a
								href={project.gitLink}
								target="_blank"
								rel="noreferrer"
							>
								<div className="github button">
									GitHub <i className="fab fa-github"></i>
								</div>
							</a>
						</div>
					</div>
				</div>
			);
		});
	};

	return (
		<div className="projects">
			<div className="projects-heading" data-aos="fade-down">
				Projects
			</div>
			<div
				className="projects-container"
				data-aos="fade-in"
				data-aos-duration="1250"
				data-aos-delay="1500"
			>
				{renderProjects()}
			</div>
		</div>
	);
};

export default Projects;
